export const UPDATE_REPORTS_STATE = "UPDATE_REPORTS_STATE"
export const REPORT_DETAILS_LOADED = "REPORT_DETAILS_LOADED"



// WEBPACK FOOTER //
// ./src/data/redux/reports_details/actiontypes.js